import { MdOutlineWhatsapp, MdOutlineQuestionAnswer } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/447458107868';

const faqData = [
    {
        category: "Questions sur l'inscription et le compte",
        questions: [
            {
                q: 'Comment créer un compte acheteur sur la plateforme ?',
                a: "Pour créer un compte acheteur, vous devez vous rendre sur la page d'inscription de la plateforme. Vous devrez choisir un abonnement et remplir les informations demandées, telles que votre nom, prénom, adresse e-mail, et créer un mot de passe sécurisé. Une fois l'inscription terminée, vous recevrez un e-mail de confirmation pour valider votre compte.",
            },
            {
                q: "Est-ce que l'inscription est gratuite ?",
                a: "L'inscription n'est pas gratuite. Le coût de l'inscription dépend de l'abonnement que vous choisissez. Chaque abonnement offre différents niveaux d'accès aux services de la plateforme, avec des fonctionnalités et des tarifs variés en fonction de vos besoins.",
            },
            {
                q: 'Comment modifier mes informations de compte (email, coordonnées bancaires, etc.) ?',
                a: "Pour modifier vos informations de compte, connectez-vous à votre compte et accédez à la section 'Mon compte'. Vous y trouverez les options pour mettre à jour votre adresse e-mail, vos coordonnées bancaires et d'autres informations personnelles.",
            },
        ],
    },
    {
        category: "Questions sur l'achat de leads",
        questions: [
            {
                q: 'Comment acheter des leads sur la plateforme ?',
                a: "Pour acheter des leads, connectez-vous à votre compte et accédez à la section dédiée à l'achat de leads. Vous pourrez y consulter différentes catégories de leads, choisir ceux qui vous intéressent et procéder au paiement en ligne pour finaliser votre achat.",
            },
            {
                q: 'Où puis-je consulter les offres de leads disponibles ?',
                a: "Les offres de leads sont accessibles dans la section 'Marketplace' de la plateforme. Vous y trouverez une variété de leads classés par catégories, industries, et critères de ciblage.",
            },
            {
                q: 'Puis-je acheter des leads en grande quantité ?',
                a: "Oui, vous pouvez acheter des leads en grande quantité. La plateforme permet aux acheteurs d'acquérir des lots de leads selon leurs besoins. Si vous avez des exigences spécifiques concernant la quantité ou le type de leads, vous pouvez également contacter notre support pour discuter d'une offre personnalisée.",
            },
            {
                q: 'Quand vais-je recevoir mes leads ?',
                a: "Les leads sont généralement envoyés immédiatement après la validation de votre paiement. Vous recevrez un e-mail de confirmation, et les informations relatives aux leads achetés seront disponibles dans votre espace personnel sur la plateforme.",
            },
        ],
    },
    {
        category: 'Questions sur les prix et les paiements',
        questions: [
            {
                q: 'Comment sont fixés les prix des leads ?',
                a: "Les prix des leads sont déterminés en fonction de plusieurs critères, notamment le type de lead, le secteur d'activité, le niveau de qualification du lead, ainsi que la demande pour ces types de données.",
            },
            {
                q: 'Quels modes de paiement sont acceptés sur la plateforme ?',
                a: 'Actuellement, nous acceptons les paiements par carte bancaire (Visa, MasterCard, etc.), et bientôt, nous ajouterons également le virement bancaire.',
            },
            {
                q: 'Quand et comment suis-je facturé pour mes achats de leads ?',
                a: 'Vous recevrez la facture à la fin de la mission, une fois que les leads auront été livrés et que la transaction aura été complétée.',
            },
            {
                q: 'Puis-je acheter des leads au coût unitaire ?',
                a: "Non, l'achat minimum est pour le moment de 50 leads. Vous ne pouvez pas acheter de leads à l'unité, mais nous proposons des lots de 50 leads ou plus pour répondre à vos besoins.",
            },
        ],
    },
    {
        category: 'Questions sur la qualité des leads',
        questions: [
            {
                q: 'Comment la plateforme garantit-elle la qualité des leads ?',
                a: "La qualité des leads est garantie par un processus de vérification rigoureux. Nous effectuons des contrôles pour nous assurer que les informations sont récentes, pertinentes et qualifiées selon des critères spécifiques.",
            },
            {
                q: 'Que faire si un lead ne correspond pas à mes attentes ou critères ?',
                a: 'Si un lead ne correspond pas à vos attentes ou critères, nous vous encourageons à contacter notre service client. Nous examinerons votre demande et, selon la situation, nous pourrons vous offrir un remboursement ou un remplacement.',
            },
            {
                q: "Puis-je demander un remboursement ou un remplacement pour un lead qui n'est pas valide ?",
                a: "Oui, vous pouvez demander un remboursement ou un remplacement pour un lead qui n'est pas valide, à condition que celui-ci ne respecte pas les critères définis lors de votre commande.",
            },
        ],
    },
    {
        category: 'Questions sur la livraison des leads',
        questions: [
            {
                q: 'Comment les leads sont-ils livrés une fois achetés ?',
                a: "Une fois vos leads achetés, ils vous sont envoyés automatiquement pour garantir leur instantanéité. Vous pouvez les recevoir directement par e-mail à l'adresse que vous avez indiquée lors de votre inscription.",
            },
            {
                q: 'Y a-t-il un délai de livraison pour recevoir mes leads ?',
                a: 'Les leads sont envoyés immédiatement après la validation de votre commande et paiement selon la disponibilité et le type de leads. Le délai de livraison peut varier entre 1 semaine et 1 mois.',
            },
            {
                q: 'Est-ce que je peux recevoir les leads par email, API ou un autre format ?',
                a: "Oui, vous pouvez recevoir vos leads par e-mail ou les intégrer directement dans votre CRM via les intégrations proposées par la plateforme. Les leads peuvent également être envoyés sur Google Sheets si vous préférez ce format.",
            },
        ],
    },
    {
        category: 'Questions sur la protection des données',
        questions: [
            {
                q: 'Comment la plateforme protège-t-elle les données personnelles des leads ?',
                a: "La plateforme protège les données personnelles des leads en utilisant des technologies de sécurité avancées, telles que le cryptage des données pendant leur transmission et leur stockage.",
            },
            {
                q: 'Que faire si je reçois des leads non conformes à la législation européenne ?',
                a: 'Si vous recevez des leads non conformes aux réglementations européennes, notamment le RGPD, vous devez contacter notre support immédiatement. Nous procéderons à une vérification avec nos partenaires.',
            },
        ],
    },
    {
        category: 'Questions sur les retours et réclamations',
        questions: [
            {
                q: "Que faire si un lead que j'ai acheté est erroné ou invalide ?",
                a: "Si vous constatez qu'un lead acheté est erroné ou invalide, vous pouvez contacter notre support client. Nous examinerons le problème et, si le lead ne respecte pas les critères de qualité, nous vous proposerons un remplacement ou un remboursement.",
            },
            {
                q: 'Comment signaler un lead frauduleux ou incorrect ?',
                a: 'Si vous avez reçu un lead que vous estimez frauduleux ou incorrect, veuillez nous en informer immédiatement via notre support. Nous enquêterons sur la situation et prendrons les mesures appropriées pour résoudre le problème.',
            },
        ],
    },
];

const BuyerAssistancePage = () => {
    return (
        <div className="mx-auto w-full max-w-6xl px-1 pb-6">
            {/* WhatsApp hero */}
            <div className="relative overflow-hidden rounded-2xl bg-leadrs-green-focus px-8 py-10">
                <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white opacity-5" />
                <div className="absolute -bottom-8 -left-8 h-36 w-36 rounded-full bg-white opacity-5" />
                <div className="relative flex flex-col items-center gap-5 text-center">
                    <FaWhatsapp className="h-16 w-16 text-white" />
                    <div>
                        <h1 className="font-crimson text-3xl font-semibold text-white md:text-4xl">
                            Une question ? On est là.
                        </h1>
                        <p className="mx-auto mt-3 max-w-lg font-geist text-sm leading-relaxed text-white opacity-80">
                            Notre équipe répond directement sur WhatsApp. Parlez-nous de vos commandes, de vos leads ou de tout problème — nous vous répondons rapidement.
                        </p>
                    </div>
                    <button
                        className="flex items-center gap-2 rounded-xl bg-white px-6 py-3 font-geist text-sm font-semibold text-leadrs-green-focus hover:opacity-90 transition-opacity"
                        onClick={() => window.open(WHATSAPP_URL, '_blank')}
                    >
                        <MdOutlineWhatsapp className="h-5 w-5" />
                        Nous contacter sur WhatsApp
                    </button>
                </div>
            </div>

            {/* FAQ */}
            <div className="mt-8">
                <div className="mb-5 flex items-center gap-3">
                    <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-yellow-soft">
                        <MdOutlineQuestionAnswer className="h-4 w-4 text-leadrs-yellow-focus" />
                    </div>
                    <div>
                        <h2 className="font-geist text-lg font-semibold text-leadrs-text">Foire Aux Questions</h2>
                        <p className="font-geist text-xs text-leadrs-text-soft">Retrouvez les réponses aux questions les plus fréquentes.</p>
                    </div>
                </div>

                <div className="space-y-4">
                    {faqData.map((section, idx) => (
                        <div key={idx} className="rounded-xl border border-leadrs-stroke bg-white px-5 py-5">
                            <div className="mb-4 flex items-center gap-3 border-b border-leadrs-stroke pb-3">
                                <h3 className="font-geist text-sm font-semibold text-leadrs-text">
                                    {section.category}
                                </h3>
                                <span className="ml-auto rounded-full bg-leadrs-bg px-2.5 py-1 font-geist text-xs font-medium text-leadrs-text-soft">
                                    {section.questions.length} questions
                                </span>
                            </div>
                            <div className="space-y-2">
                                {section.questions.map((item, qIdx) => (
                                    <details
                                        key={qIdx}
                                        className="group rounded-xl border border-leadrs-stroke bg-leadrs-bg px-4 py-3 transition-colors hover:border-leadrs-text-soft"
                                    >
                                        <summary className="cursor-pointer list-none font-geist text-sm font-semibold text-leadrs-text">
                                            <div className="flex items-center justify-between gap-3">
                                                <span>{item.q}</span>
                                                <span className="flex-shrink-0 text-leadrs-text-soft transition-transform group-open:rotate-45">+</span>
                                            </div>
                                        </summary>
                                        <p className="mt-2 font-geist text-sm leading-relaxed text-leadrs-text-soft">
                                            {item.a}
                                        </p>
                                    </details>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom WhatsApp nudge */}
            <div className="mt-6 flex items-center justify-between rounded-xl border border-leadrs-green-soft bg-leadrs-green-soft px-5 py-4">
                <div className="flex items-center gap-3">
                    <MdOutlineWhatsapp className="h-5 w-5 text-leadrs-green-focus" />
                    <p className="font-geist text-sm font-medium text-leadrs-green-focus">
                        Vous n'avez pas trouvé votre réponse ?
                    </p>
                </div>
                <button
                    className="flex items-center gap-2 rounded-xl bg-leadrs-green-focus px-4 py-2 font-geist text-xs font-semibold text-leadrs-green-soft hover:opacity-80 transition-opacity"
                    onClick={() => window.open(WHATSAPP_URL, '_blank')}
                >
                    <MdOutlineWhatsapp className="h-4 w-4" />
                    WhatsApp
                </button>
            </div>
        </div>
    );
};

export default BuyerAssistancePage;
